import { baseApi } from "./index";

export const visualApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getMainVisual: builder.query({
            query: ({ page = "/", locale }) => ({
                url: "/main-visual",
                method: "GET",
                params: {locale,},
            }),
            providesTags: ["MainVisual"],
        }),
    }),
});

export const {
    useGetMainVisualQuery,
} = visualApi;
